import { useQuery } from 'react-query'

const useData = ({ dataAdapter, fetchData, selectedParams }) => {
  return useQuery(`${dataAdapter.name}Data`, () => fetchData(selectedParams), {
    staleTime: Infinity
  })
}

export default useData
